/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/** Collapse / minimize diagonal arrows (16×16). Mirrors `ExpandAltIcon`. Color via `currentColor`. */
const CollapseAltIcon = ({
  size = 16,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path
      d="M9.75 3.5V6.25H12.5M9.75 6.25L13.5 2.5M6.25 12.5V9.75H3.5M6.25 9.75L2.5 13.5"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

CollapseAltIcon.propTypes = iconPropTypes;

export default CollapseAltIcon;
